(() => {
  const MOBILE_MAX = 989;
  const BAR_ID = 'hartli-sticky-atc';

  function isMobile() {
    return window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
  }

  function isProductPage() {
    return document.body?.classList.contains('template-product') || location.pathname.includes('/products/');
  }

  function findMainAtcButton() {
    return (
      document.querySelector('button[id^="ProductSubmitButton-"][name="add"]') ||
      document.querySelector('.product-form__buttons button[name="add"]') ||
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('form[action^="/cart/add"] button[type="submit"]') ||
      document.querySelector('button[name="add"]')
    );
  }

  function ensureBodyPadding() {
    document.body.classList.add('hartli-has-sticky-atc');
  }

  function setVisible(bar, yes) {
    // Smooth fly in/out (cannot be broken by CSS)
    if (yes) {
      bar.style.transform = 'translateY(0)';
      bar.style.opacity = '1';
      bar.style.pointerEvents = 'auto';
    } else {
      bar.style.transform = 'translateY(120%)';
      bar.style.opacity = '0';
      bar.style.pointerEvents = 'none';
    }
  }

  function buildClonedButton(mainBtn) {
    const clone = mainBtn.cloneNode(true);

    // Avoid duplicate ids / accidental form submit
    if (clone.id) clone.removeAttribute('id');
    clone.setAttribute('type', 'button');
    clone.removeAttribute('name');
    clone.removeAttribute('form');

    clone.classList.add('hartli-sticky-atc__btn');
    return clone;
  }

  function createBar(mainBtn) {
    const bar = document.createElement('div');
    bar.id = BAR_ID;

    // Stable layout + seamless background
    bar.style.position = 'fixed';
    bar.style.left = '0';
    bar.style.right = '0';
    bar.style.bottom = '0';
    bar.style.zIndex = '50';
    bar.style.padding = '10px 12px';
    bar.style.paddingBottom = 'calc(10px + env(safe-area-inset-bottom))';
    bar.style.background = '#FAF7EE';
    bar.style.borderTop = 'none';

    // Smooth transition (Hartli calm)
    bar.style.transition = 'transform 320ms cubic-bezier(0.22, 1, 0.36, 1), opacity 240ms ease';
    bar.style.willChange = 'transform, opacity';

    // Start hidden until we decide (prevents flashing)
    bar.style.transform = 'translateY(120%)';
    bar.style.opacity = '0';
    bar.style.pointerEvents = 'none';

    const inner = document.createElement('div');
    inner.className = 'hartli-sticky-atc__inner';
    inner.style.maxWidth = '640px';
    inner.style.margin = '0 auto';

    const stickyBtn = buildClonedButton(mainBtn);
    inner.appendChild(stickyBtn);
    bar.appendChild(inner);

    document.body.appendChild(bar);
    ensureBodyPadding();

    stickyBtn.addEventListener('click', () => {
      if (mainBtn.disabled) return;
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => mainBtn.click(), 250);
    });

    return { bar, stickyBtn };
  }

  function syncState(stickyBtn, mainBtn) {
    const label = (mainBtn.textContent || '').trim();
    if (label) stickyBtn.textContent = label;

    stickyBtn.disabled = !!mainBtn.disabled;
    stickyBtn.setAttribute('aria-disabled', String(!!mainBtn.disabled));
  }

  // Hide the sticky CTA only while the real button is visible on screen.
function shouldHideSticky(mainBtn) {
  const rect = mainBtn.getBoundingClientRect();

  return rect.top < window.innerHeight && rect.bottom > 0;
}

  function isCartDrawerOpen() {
  return !!(
    document.querySelector('cart-drawer.active') ||
    document.querySelector('.cart-drawer.active') ||
    document.querySelector('#CartDrawer.active') ||
    document.querySelector('cart-drawer[open]') ||
    document.querySelector('.drawer.active') ||
    document.body.classList.contains('overflow-hidden')
  );
}

  function init() {
    if (!isMobile() || !isProductPage()) return;

    let mainBtn = null;
    let bar = null;
    let stickyBtn = null;

    const tick = () => {
      if (!mainBtn || !document.contains(mainBtn)) mainBtn = findMainAtcButton();
      if (!mainBtn) return;

      if (!bar || !document.contains(bar) || !stickyBtn || !document.contains(stickyBtn)) {
        const created = createBar(mainBtn);
        bar = created.bar;
        stickyBtn = created.stickyBtn;
      }

      syncState(stickyBtn, mainBtn);

      // THIS guarantees never seeing two buttons:
      setVisible(bar, !shouldHideSticky(mainBtn) && !isCartDrawerOpen());
    };

    tick();
    setInterval(tick, 150);
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
